import { useState } from "react";

import { useTranslation } from "../../core/translation.core";
import { ChildProductFormData, Product } from "../../types/product";
import { useForm } from "react-hook-form";
import ProductAttributeEditor from "./productAttributeEditor";
import { LabelAndInput } from "../reuseables/form.comp";
import { ErrorMessage } from "@hookform/error-message";
import productCore from "../../core/product.core";
import { useQueryClient } from "@tanstack/react-query";

export default function ChildProductQuickEditor({ parentProduct }: { parentProduct: Product }) {
  const { msg, t } = useTranslation();
  const [isAdding, setIsAdding] = useState(false);

  if (!parentProduct) return null;
  if (parentProduct.productType !== "variationParent") return null;

  return (
    <div className="space-y-4">
      {!isAdding && (
        <button
          type="button"
          id="add-child"
          className="bg-her-dodgerblue text-white px-4 py-1 rounded-md"
          onClick={() => setIsAdding(true)}
        >
          {t(msg.product.addChild)}
        </button>
      )}
      {isAdding && <AddChildProductEditor parentProduct={parentProduct} />}
    </div>
  );
}

function AddChildProductEditor({ parentProduct }: { parentProduct: Product }) {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();
  const methods = useForm<ChildProductFormData>({
    defaultValues: {
      attributes: [{ attributeId: "", name: "", type: "string", value: { en: "", zhHans: "", zhHant: "" } }],
      // name: props.parentProduct.name,
    },
  });

  async function onSubmit() {
    const data = methods.getValues();
    data.price = parentProduct.price;

    const res = await productCore.createChildProduct(data, parentProduct);
    if (res.status === 200) {
      queryClient.invalidateQueries({ queryKey: ["productSingle", parentProduct.id] });
      queryClient.invalidateQueries({ queryKey: ["products"] });
    } else {
      const resData = res.data;
      if (resData && (resData as any).errors?.length > 0) {
        productCore.setDuplicateError(methods, resData as any);
      }
    }
  }

  return (
    <div id="child-product-quick-editor" className="space-y-4">
      <LabelAndInput
        register={methods.register}
        fieldName="sku"
        topLabelCss="w-full block text-xs"
        labelCss="-mb-[.3px]"
        label={t(msg.product.sku)}
        registerOptions={{ required: true }}
      />
      <ErrorMessage
        name="sku"
        errors={methods.formState.errors}
        render={({ message }) => <div className="text-red-400 text-xs">{message}</div>}
      />
      <ProductAttributeEditor methods={methods as any} />

      <button
        id="add-child-product"
        type="button"
        className="bg-her-dodgerblue text-white px-4 py-1 rounded-md"
        onClick={onSubmit}
      >
        {t(msg.product.addChild)}
      </button>
    </div>
  );
}
